import { useSelector } from "react-redux";
import "./ProductOffer.css";

const ProductOffer = ({ selectedProduct }) => {
  const basket = useSelector((state) => state.basket.basket || []);

  const category = (selectedProduct?.category || "").toLowerCase();

  const isTee =
    category.includes("tee") ||
    category.includes("t-shirt") ||
    category.includes("shirt");

  if (!isTee) return null;

  // Count number of tees in basket
  const teeCount = basket.reduce((acc, item) => {
    const cat = (item.title || "").toLowerCase();
    if (
      cat.includes("tee") ||
      cat.includes("t-shirt") ||
      cat.includes("shirt")
    ) {
      return acc + (item.quantity || 1);
    }
    return acc;
  }, 0);

  let offerMsg = null;
  if (teeCount >= 2) {
    offerMsg = (
      <>
        <strong>🔥 10% off applied</strong>
        <span>Auto-applied at checkout</span>
      </>
    );
  } else if (teeCount === 1) {
    offerMsg = (
      <>
        <strong>🔥 Add 1 more tee to unlock 10% off</strong>
        <span>Auto-applied at checkout</span>
      </>
    );
  } else {
    offerMsg = (
      <>
        <strong>🔥 2 tees = 10% off</strong>
        <span>Auto-applied at checkout</span>
      </>
    );
  }

  return <div className="product-offer">{offerMsg}</div>;
};

export default ProductOffer;
